import type { FieldMatcher } from '@cdw-ae/filter-bar-interfaces';

export const BooleanMatcher: FieldMatcher = {
  name: 'boolean',
  displayName: 'Boolean',
  options: { setValue: (): string => 'true', chipFormatter: (): string => '' },
};